import React, { useRef, useEffect } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { privacyPolicy } from "../data/links";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const Privacy = () => {
  const sectionRefs = useRef([]);
  sectionRefs.current = [];

  const addToRefs = (el) => {
    if (el && !sectionRefs.current.includes(el)) {
      sectionRefs.current.push(el);
    }
  };

  useEffect(() => {
    sectionRefs.current.forEach((el, i) => {
      gsap.fromTo(
        el,
        { opacity: 0, y: 50 },
        {
          opacity: 1,
          y: 0,
          duration: 0.8,
          delay: i * 0.1,
          ease: "power3.out",
          scrollTrigger: {
            trigger: el,
            start: "top 80%",
            toggleActions: "play none none none",
          },
        },
      );
    });
  }, []);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <div className="bg-black">
        <Navbar />
      </div>
      <div className="bg-gradient-to-b from-white to-gray-50 py-16 px-4 sm:px-8 md:px-16 lg:px-24">
        <div className="max-w-5xl mx-auto">
          {/* Header Section */}
          <div className="text-center mb-14">
            <h1 className="text-3xl sm:text-4xl md:text-5xl font-extrabold tracking-tight text-gray-900">
              Privacy Policy
            </h1>
            <p className="mt-4 text-gray-600 text-base sm:text-lg md:text-xl max-w-3xl mx-auto leading-relaxed">
              At Gift of God Fragrances LLC, customer satisfaction is our top
              priority. We stand behind every product we offer and ensure
              authentic branded fragrances.
            </p>
          </div>

          {/* Policy Sections */}
          <div className="space-y-6">
            {privacyPolicy.map((section, index) => (
              <div
                key={index}
                ref={addToRefs}
                className="bg-white rounded-2xl shadow-sm hover:shadow-md transition-shadow duration-300 border border-gray-100 p-5 sm:p-6 md:p-8"
              >
                {/* Title */}
                <h2 className="text-lg sm:text-xl md:text-2xl font-semibold text-gray-900 mb-4 border-l-4 border-black pl-3">
                  {section.title}
                </h2>

                {/* Content */}
                <div className="space-y-2">
                  {section.content.map((line, idx) => (
                    <p
                      key={idx}
                      className="text-gray-600 text-sm sm:text-base md:text-lg leading-relaxed"
                    >
                      {line}
                    </p>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Privacy;
